import React from "react";
import styled, { css } from "styled-components";
import { Wrapper as ModalWrapper } from "./../../../../components/manageMyRepaymentModal/manageMyRepaymentModal.styles";
import { withLoanForm } from "../../../../../../components/fairGoForm/withLoanForm";
import { useLocation } from "react-router";
import { ManageRepaymentForm } from "../../../../components/manageRepaymentForm";
import { Wrapper as FormWrapper } from "../makeExtraRepaymentsForms.styles";
import {
  EXTRA_REPAYMENTS_ROUTE,
  MANAGE_REPAYMENTS_INCREASE_ROUTE,
  MANAGE_ARREARS_ROUTE,
  PAY_FULL_ARREARS_ROUTE,
} from "../../route.constants";
import { bankTransferLogIncreaseEndpoint, bankTransferLogArrearsEndpoint } from "../../../../../../services/apiRoutes";
import { PRIVATE_ROUTE } from "../../../../../../route.constants";
import environmentSettings from "@constants/environmentSettings";

const Wrapper = styled.div(({ theme }) => css`
  display: flex;
  flex-direction: column;

  .bank-transfer-subtitle {
    padding: 10px 0 30px;
  }

  .payment-details-item {
    display: flex;
    justify-content: space-between;
    max-width: 270px;
    padding: 6px 0;

    p:last-child {
      font-weight: ${theme.fonts.headingWeight};
    }
  }

  .bank-payment-submit {
    display: flex;
    justify-content: flex-end;
  }

  .bank-payment-button {
    margin: 30px 0 0;
    background-color: ${theme.buttons.secondary.background};
    color: ${theme.buttons.secondary.color};
    font-size: ${theme.buttons.fontSize};
    font-weight: ${theme.buttons.fontWeight};

    @media (hover: hover) {
      &:hover {
        color: ${theme.buttons.secondary.colorHover};
        background-color: ${theme.buttons.secondary.backgroundHover};
      }
    }
  }
`);

const ModalMessage = () => {
  return (
    <ModalWrapper>
      <p>
        Thank you for letting us know. We've updated our records to indicate you
        will be making a Bank Transfer.
      </p>
    </ModalWrapper>
  );
};

export const _PayBankTransferForm = ({ accountId }) => {
  const { directDebitBank, directDebitBSB, directDebitAccountNumber } = environmentSettings;

  return (
    <Wrapper>
      <h3>How to pay?</h3>
      <p className="bank-transfer-subtitle">
        You can easily make direct deposits into our bank account using the
        details below.
      </p>
      <div className="payment-details-item">
        <p>Bank</p>
        <p>{directDebitBank}</p>
      </div>
      <div className="payment-details-item">
        <p>BSB</p>
        <p>{directDebitBSB}</p>
      </div>
      <div className="payment-details-item">
        <p>Account Number</p>
        <p>{directDebitAccountNumber}</p>
      </div>
      <div className="payment-details-item">
        <p>Reference</p>
        <p>{accountId}</p>
      </div>
    </Wrapper>
  );
};

const PayBankTransferForm = withLoanForm(_PayBankTransferForm);

export const PayBankTransfer = ({ accountId }) => {
  const matchIncreaseRepayments =
    PRIVATE_ROUTE.MANAGE_REPAYMENTS +
    MANAGE_REPAYMENTS_INCREASE_ROUTE.INCREASE +
    EXTRA_REPAYMENTS_ROUTE.BANK_TRANSFER;

  const matchManageArrears =
    PRIVATE_ROUTE.MANAGE_REPAYMENTS +
    MANAGE_ARREARS_ROUTE.ARREARS +
    EXTRA_REPAYMENTS_ROUTE.BANK_TRANSFER;

  const matchPayFullArrears =
    PRIVATE_ROUTE.MANAGE_REPAYMENTS +
    MANAGE_ARREARS_ROUTE.ARREARS +
    PAY_FULL_ARREARS_ROUTE.BANK_TRANSFER;

  let endpoint;

  const { pathname } = useLocation();
  if (pathname === matchIncreaseRepayments) {
    endpoint = bankTransferLogIncreaseEndpoint(accountId);
  } else {
    endpoint = bankTransferLogArrearsEndpoint(accountId);
  }

  const isActive =
    matchManageArrears === pathname || matchIncreaseRepayments === pathname || matchPayFullArrears === pathname;

  return (
    <FormWrapper>
      <ManageRepaymentForm
        buttonText="Confirm Payment Method"
        endpoint={endpoint}
        initialValues=""
        modalMessage={<ModalMessage />}
        isActive={isActive}
      >
        <PayBankTransferForm accountId={accountId} />
      </ManageRepaymentForm>
    </FormWrapper>
  );
};
